import client from './client';

export const listRevenue = () => client.get('/revenue').then((r) => r.data);
export const saveRevenue = (entries) => client.post('/revenue', { entries }).then((r) => r.data);
export const getYearTargets = (year) => client.get('/revenue/targets', { params: { year } }).then((r) => r.data);
export const saveYearTargets = (year, entries) => client.post('/revenue/targets', { year, entries }).then((r) => r.data);
